module.exports = __webpack_public_path__ + "static/media/CM.b41acf85.png";